/*import React, { useState } from "react";
//import {  Icon, IconButton } from "@fluentui/react";
import { ChatHelpRegular, Copy24Filled, Copy24Regular, ThumbLike24Regular } from "@fluentui/react-icons";
import { IconButton } from "@fluentui/react/lib/Button";

import "./LikeDislike.css";

interface LikeBtnProps {
    isSelected: boolean;
    direction: "Like" | "Dislike";
    messageId: number;
    onSendFeedback: (messageId: number, action: string) => void;
    onSendFeedbackMessage: (messageId: number, feedback: string, feedbackCategory: string | null) => void;
    setAnswerFeedbackForm: (status: boolean) => void;
}
export const LikeBtn = ({ isSelected, direction, messageId, onSendFeedback, onSendFeedbackMessage, setAnswerFeedbackForm }: LikeBtnProps) => {
    const [feedbackForm, setFeedbackForm] = useState(false);
    const [message, setMessage] = useState("");
    const iconName = direction + (isSelected ? "Solid" : "");
    const action = direction == "Like" ? "up" : "down";
    const title = direction == "Like" ? "I like this response." : "I did not like this response.";

    const onFeedbackClicked = async () => {
        onSendFeedback(messageId, action);
    };
    const onRemoveFeedback = async () => {
        onSendFeedback(messageId, "0");
    };
    const toggleFeedbackForm = () => {
        setFeedbackForm(!feedbackForm);
    };
    const onSubmitFeedBackForm = async () => {
        setFeedbackForm(!feedbackForm);
        onSendFeedbackMessage(messageId, message, "na");
        //alert("Thank you for your valuable Feedback!");
        //Placeholder for adding code whcih required to connect the backend to save the Feedback message.
    };

    if (action === "up") {
        return (
            <>
                <IconButton
                    // Thumbs Up Regular
                    title="Thumbs Up"
                    ariaLabel="Thumbs Up"
                    onRenderIcon={() => (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 36 36"
                            style={{
                                width: "24px",
                                height: "24px",
                                fill: "white",
                                stroke: "#2047ef",
                                strokeWidth: "3px"
                            }}
                        >
                            <path d="M12.313 5.531c0-2.9 2.124-3.583 3.312-3.562 2.413 0 3.082 2.009 3.281 3.078.248 1.33.006 4.509-.106 5.969l-.003.041a2.3 2.3 0 0 1 .515-.057h3.858c1.56 0 2.83 1.27 2.83 2.83 0 .806-.259 1.535-.765 2.05 1.044.461 1.765 1.428 1.765 2.544 0 1.023-.463 1.92-1.364 2.418.823.511 1.364 1.366 1.364 2.332 0 1.107-.543 2.069-1.598 2.533.375.386.598.96.598 1.794 0 1.38-.969 2.502-2.83 2.502h-3.858q-.068 0-.134-.003h-3.131C5.609 30.172 5 23.406 5 20.656c0-5.156 2.298-6.689 4.34-8.051.966-.644 1.875-1.25 2.457-2.183.488-.783.515-1.5.515-4.89" />
                        </svg>
                    )}
                    onClick={() => {
                        <IconButton
                            // Thumbs Up Fill
                            title="Thumbs Up Fill"
                            ariaLabel="Thumbs Up Fill"
                            onRenderIcon={() => (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 36 36"
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        fill: "white",
                                        stroke: "#2047ef",
                                        strokeWidth: "3px"
                                    }}
                                >
                                    <path d="M12.313 5.531c0-2.9 2.124-3.583 3.312-3.562 2.413 0 3.082 2.009 3.281 3.078.248 1.33.006 4.509-.106 5.969l-.003.041a2.3 2.3 0 0 1 .515-.057h3.858c1.56 0 2.83 1.27 2.83 2.83 0 .806-.259 1.535-.765 2.05 1.044.461 1.765 1.428 1.765 2.544 0 1.023-.463 1.92-1.364 2.418.823.511 1.364 1.366 1.364 2.332 0 1.107-.543 2.069-1.598 2.533.375.386.598.96.598 1.794 0 1.38-.969 2.502-2.83 2.502h-3.858q-.068 0-.134-.003h-3.131C5.609 30.172 5 23.406 5 20.656c0-5.156 2.298-6.689 4.34-8.051.966-.644 1.875-1.25 2.457-2.183.488-.783.515-1.5.515-4.89" />
                                </svg>
                            )}
                        />;
                        if (iconName === "Like") {
                            onRemoveFeedback();
                        } else {
                            onFeedbackClicked();
                            setAnswerFeedbackForm(false);
                        }
                    }}
                />
            </>
        );
    } else if (action === "down") {
        return (
            <>
                <IconButton
                    style={{ color: "#2047ef" }}
                    iconProps={{ iconName }}
                    title={title}
                    ariaLabel={title}
                    onClick={() => {
                        if (iconName === "DislikeSolid") {
                            onRemoveFeedback();
                            setAnswerFeedbackForm(false);
                        } else {
                            onFeedbackClicked();
                            toggleFeedbackForm();
                            setAnswerFeedbackForm(true);
                        }
                    }}
                />
            </>
        );
    } else {
        return <div></div>;
    }
    //if (action === "up") {
    //    return (
    //        <>
    //            <IconButton
    //                style={{ color: "#2047ef" }}
    //                iconProps={{ iconName }}
    //                title={title}
    //                ariaLabel={title}
    //                onClick={() => {
    //                    if (iconName === "Like") {
    //                        onRemoveFeedback();
    //                    } else {
    //                        onFeedbackClicked();
    //                        setAnswerFeedbackForm(false);
    //                    }
    //                }}
    //            />
    //        </>
    //    );
    //} else if (action === "down") {
    //    return (
    //        <>
    //            <IconButton
    //                style={{ color: "#2047ef" }}
    //                iconProps={{ iconName }}
    //                title={title}
    //                ariaLabel={title}
    //                onClick={() => {
    //                    if (iconName === "DislikeSolid") {
    //                        onRemoveFeedback();
    //                        setAnswerFeedbackForm(false);
    //                    } else {
    //                        onFeedbackClicked();
    //                        toggleFeedbackForm();
    //                        setAnswerFeedbackForm(true);
    //                    }
    //                }}
    //            />
    //        </>
    //    );
    //} else {
    //    return <div></div>;
    //}
}; // */
import React, { useState } from "react";
import { IconButton } from "@fluentui/react/lib/Button";
import "./LikeDislike.css"; // Import your CSS file

interface LikeBtnProps {
    isSelected: boolean;
    direction: "Like" | "Dislike";
    messageId: number;
    onSendFeedback: (messageId: number, action: string) => void;
    onSendFeedbackMessage: (messageId: number, feedback: string, feedbackCategory: string | null) => void;
    setAnswerFeedbackForm: (status: boolean) => void;
}

export const LikeBtn = ({ isSelected, direction, messageId, onSendFeedback, onSendFeedbackMessage, setAnswerFeedbackForm }: LikeBtnProps) => {
    const [feedbackForm, setFeedbackForm] = useState(false);
    const [message, setMessage] = useState("");
    const action = direction === "Like" ? "up" : "down"; // Consistent action names
    const title = direction === "Like" ? "I like this response." : "I did not like this response.";

    const onFeedbackClicked = async () => {
        onSendFeedback(messageId, action);
    };

    const onRemoveFeedback = async () => {
        onSendFeedback(messageId, "0"); // Send "0" for removal
    };

    const toggleFeedbackForm = () => {
        setFeedbackForm(!feedbackForm);
    };

    const onSubmitFeedBackForm = async () => {
        setFeedbackForm(false); // Close form after submission
        onSendFeedbackMessage(messageId, message, "na");
    };

    const renderIcon = () => {
        // Determine fill color based on isSelected and direction
        let fillColor = isSelected ? "#2047ef" : "white";
        let strokeWidth = isSelected ? "0" : "3px";
        let pathD = "";

        if (direction === "Like") {
            pathD =
                "M12.313 5.531c0-2.9 2.124-3.583 3.312-3.562 2.413 0 3.082 2.009 3.281 3.078.248 1.33.006 4.509-.106 5.969l-.003.041a2.3 2.3 0 0 1 .515-.057h3.858c1.56 0 2.83 1.27 2.83 2.83 0 .806-.259 1.535-.765 2.05 1.044.461 1.765 1.428 1.765 2.544 0 1.023-.463 1.92-1.364 2.418.823.511 1.364 1.366 1.364 2.332 0 1.107-.543 2.069-1.598 2.533.375.386.598.96.598 1.794 0 1.38-.969 2.502-2.83 2.502h-3.858q-.068 0-.134-.003h-3.131C5.609 30.172 5 23.406 5 20.656c0-5.156 2.298-6.689 4.34-8.051.966-.644 1.875-1.25 2.457-2.183.488-.783.515-1.5.515-4.89";
        } else {
            pathD =
                "M19.688 26.44c0 2.9-2.125 3.584-3.313 3.563-2.412 0-3.082-2.01-3.281-3.078-.248-1.33-.005-4.51.106-5.97l.003-.04q-.238.056-.515.057H8.83c-1.56 0-2.83-1.27-2.83-2.83 0-.806.259-1.535.765-2.051C5.721 15.63 5 14.663 5 13.548c0-1.023.463-1.921 1.364-2.418C5.541 10.618 5 9.764 5 8.798c0-1.108.543-2.07 1.598-2.534C6.223 5.878 6 5.304 6 4.47c0-1.379.969-2.502 2.83-2.502h3.858q.068 0 .134.004h3.131C26.391 1.8 27 8.565 27 11.315c0 5.156-2.298 6.69-4.34 8.052-.966.644-1.875 1.25-2.457 2.183-.488.782-.515 1.5-.515 4.89";
        }

        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 36 36"
                style={{
                    width: "24px",
                    height: "24px",
                    fill: fillColor,
                    stroke: "#2047ef",
                    strokeWidth: strokeWidth
                }}
            >
                <path d={pathD} />
            </svg>
        );
    };

    // onClick handler for the IconButton
    const handleClick = () => {
        if (isSelected) {
            onRemoveFeedback();
            if (direction === "Dislike") {
                setAnswerFeedbackForm(false); // Close feedback form if dislike removed
            }
        } else {
            onFeedbackClicked();
            if (direction === "Dislike") {
                toggleFeedbackForm();
                setAnswerFeedbackForm(true); // Open feedback form if dislike added
            } else {
                setAnswerFeedbackForm(false); // Close feedback form if like added
            }
        }
    };

    return (
        <IconButton
            style={{ color: "#2047ef" }}
            title={title}
            ariaLabel={title}
            onClick={handleClick}
            onRenderIcon={renderIcon} // Use onRenderIcon for custom SVG
        />
    );
};
